
import React from 'react';
import actions from '../actions/TransInformationAction';
import TransInformationStore from '../stores/TransInformationStore';
import { withRouter } from 'react-router-dom';

var trstyle = {
    float: 'right',
    margin: '10px 15px 0px 0px'
}

class MobileNumber extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Mobile: '',
            MobileInfo: [],
        };
        this.getotpDetails = this.getotpDetails.bind(this);
    }

    getotpDetails() {
        var MobileInfo = TransInformationStore.getotpDetails()
        this.setState({ MobileInfo: TransInformationStore.getotpDetails() });
        if (typeof MobileInfo === 'object') {
            this.props.history.push('/EnterOtp')
        }
        else {
            if (MobileInfo.indexOf('undefined') > 0) {
                alert("Mobile Number Does not Exist")
            }
        }

    }

    componentWillMount() {
        TransInformationStore.addListener('getOTPInfo', this.getotpDetails)
    }

    componentWillUnmount() {
        TransInformationStore.removeListener('getOTPInfo', this.getotpDetails)
    }

    GoOtp(e) {
        e.preventDefault();
        actions.GoOtp(this.state);
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div className="page_single layout_fullwidth_padding">
                                <div className="contactform">
                                    <form className="" id="CustomForm" method="post" action="">
                                        <div className="form_row">
                                            <label htmlFor="Mobile">मोबाईल न. :</label>
                                            <input Number="text" className="form_input" id="Mobile" name="Mobile" value={this.state.Mobile} onChange
                                                ={(e) => this.handleInputChange(e)} placeholder="मोबाईल न.टाका " />
                                        </div>
                                        <div className="form_row">
                                            <button type="submit" style={trstyle} className="btn  btn-primary" onClick={(e) => this.GoOtp(e)}>Submit Number </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(MobileNumber)





// WEBPACK FOOTER //
// ./src/component/MobileNumber.jsx